@if (canPrint()) {
<!-- transcluded header -->
<div class="w-12 flex flex-justify-between flex-bottom wrap">
    <div class="c-6 c-12-s c-12-m m-b-0">
        <ng-content></ng-content>
    </div>
    <!-- navigation -->
    <div [class.hidden]="(listing?.models?.length || 0) <= pcSlides || client.sizeId < 2"
         [style.width]="(listing?.models?.length || 0) <= pcSlides || client.sizeId < 2 ? '0' : 'auto'"
         class="right">
        <button class="m-r-3 swiper-top-arrow-button"
                [ngClass]="'product-prev-' + getEnginesName()"
                aria-label="Previous slide">
            <i class="icon-chevron-left  inline-flex col-w"
               aria-hidden="true"></i>

        </button>

        <button class="swiper-top-arrow-button"
                [ngClass]="'product-next-' + getEnginesName()"
                aria-label="Next slide">
            <i class="icon-chevron-right inline-flex col-w"
               aria-hidden="true"></i>
        </button>
    </div>
</div>

<!-- slider -->
<carousel class="wrap default-scrollbar swiper-slide-per-view swiper-show-outside-wrap p-t-8 p-b-8"
          [slidesPerView]="'auto'"
          [navigation]="{
                    nextEl: '.product-next-' + getEnginesName(),
                    prevEl: '.product-prev-' + getEnginesName()
                }"
          [freeMode]="true"
          [style.--pc-slides-ceil]="pcSlidesCeil"
          [style.--pc-slides]="pcSlides"
          [style.--pc-gutter]="pcGutter"
          [scrollbar]="{ draggable: true }"
          [mousewheel]="{forceToAxis: true}"
          imageViewRoot>
    @if (listing) {
    @for (model of listing.models; track model.id; let index = $index) {
    <ng-template swiperSlide>
        <product [model]="model"
                 [gtmImpressionTrack]="{productId: model.id, position: i+1, list: 'Related products'}"
                 [listName]="'Related products'"
                 [listPosition]="index + 1"
                 class="block m-b-4-s m-b-4-m height-100"></product>
    </ng-template>
    }
    }
</carousel>
}